import { CardItem } from '@bloomays-lib/ui.shared';

import { ITalent, ProfileNetwork } from '@bloomays-lib/types.shared';
import { getATSTalentUrl, getCollectiveTalentUrl, getProfileByNetwork } from '@bloomays-lib/utils.shared';
import { ActionMenuItem } from '../components/organisms/ResponsiveActionMenu';
import { styled } from '@mui/material/styles';
import { ClipboardCopy, Logo } from '@bloomays-lib/ui.shared';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import type { TFunction } from 'i18next';
import lk from '../graphic-charter/icons/LK.svg';
import toit from '../graphic-charter/icons/toit.svg';
import hw from '../graphic-charter/icons/hellowork.svg';
import hs from '../graphic-charter/icons/HireSweet.svg';
import collective from '../graphic-charter/icons/collective.svg';
import cv from '../graphic-charter/icons/CV.svg';
import redirect from '../graphic-charter/icons/redirect.svg';
import config from './configService';

export const getTalentActions = (
  talent: ITalent,
  origin: 'searchPage' | 'talentPage',
  handleOpenSyncTalent: () => void,
  t: TFunction,
) => {
  const getTranslatedValue = (key: string) => t(key, { ns: 'talentSheet' });
  const LK = getProfileByNetwork(talent?.profiles || [], ProfileNetwork.LinkedIn);
  const TOIT = getProfileByNetwork(talent?.profiles || [], ProfileNetwork.TurnoverIT);
  const HW = getProfileByNetwork(talent?.profiles || [], ProfileNetwork.HelloWork);
  const HSUrl = talent?.hiresweetId ? getATSTalentUrl(config().env, talent.hiresweetId) : undefined;
  const collectiveUrl = talent.collectiveId?.trim() ? getCollectiveTalentUrl(talent.collectiveId) : undefined;
  const urlFullTalentSheet = `${import.meta.env.VITE_PUBLIC_APP_ENDPOINT}talents/${talent.id}`;

  // Préparation des actions pour le menu responsive
  const actions: ActionMenuItem[] = [
    ...(HSUrl
      ? [
          {
            icon: <StyledHoverLogo image={hs} alt={getTranslatedValue('hiresweetMenuAria')} />,
            label: getTranslatedValue('hiresweetMenuLabel'),
            onClick: () => window.open(HSUrl),
          },
        ]
      : []),
    ...(collectiveUrl
      ? [
          {
            icon: <StyledHoverLogo image={collective} alt={getTranslatedValue('collectiveProfileMenuAria')} />,
            label: getTranslatedValue('collectiveProfileMenuLabel'),
            onClick: () => window.open(collectiveUrl, '_blank', 'noopener,noreferrer'),
          },
        ]
      : []),
    ...(HW?.url
      ? [
          {
            icon: <StyledHoverLogo image={hw} alt={getTranslatedValue('helloWorkMenuAria')} />,
            label: getTranslatedValue('helloWorkMenuLabel'),
            onClick: () => window.open(HW.url),
          },
        ]
      : []),
    ...(TOIT?.url
      ? [
          {
            icon: <StyledHoverLogo image={toit} alt={getTranslatedValue('turnoverItMenuAria')} />,
            label: getTranslatedValue('turnoverItMenuLabel'),
            onClick: () => window.open(TOIT.url),
          },
        ]
      : []),
    ...(LK?.url
      ? [
          {
            icon: <StyledHoverLogo image={lk} alt={getTranslatedValue('linkedInMenuAria')} />,
            label: getTranslatedValue('linkedInMenuLabel'),
            onClick: () => window.open(LK.url),
          },
        ]
      : []),
    {
      icon: <ClipboardCopy copyText={urlFullTalentSheet} />,
      label: getTranslatedValue('cpLink'),
      onClick: undefined,
    },
    ...(origin === 'searchPage'
      ? [
          {
            icon: <StyledHoverLogo image={redirect} alt={getTranslatedValue('openTalentSheetMenuAria')} />,
            label: getTranslatedValue('openTalentSheetMenuLabel'),
            onClick: () => window.open(urlFullTalentSheet, '_blank'),
          },
        ]
      : []),
    ...(origin === 'searchPage' && talent.cv
      ? [
          {
            icon: <StyledHoverLogo image={cv} alt={getTranslatedValue('viewCvMenuAria')} />,
            label: getTranslatedValue('viewCvMenuLabel'),
            onClick: () => window.open(talent.cv, '_blank'),
          },
        ]
      : []),
    {
      icon: <CardItem variant={'pink'} size={'extraSmall'} emoji={<AddShoppingCartIcon />} />,
      label: getTranslatedValue('addToCartMenuLabel'),
      onClick: () => handleOpenSyncTalent(), // Action à définir si besoin
    },
  ];

  return actions;
};

const StyledHoverLogo = styled(Logo)(
  () => `
  &:hover {
    cursor: pointer;
  }
  width: 24px;
  height: 24px;
`,
);
